export default __webpack_public_path__ + "static/media/mitigation-drying-fan-floor-view.a74bcbc0.jpg";